export const MESSAGES_RU = {
  PROJECT_LIST_ORDER_MESSAGE: 'Самые последние проекты вверху',
  SKILLS_DATA_UPDATE_MESSAGE: 'Все навыки актуальны.',
  CONSTANTLY_SKILLS_UPGRADING_MESSAGE:
    'Постоянно совершенствую свои навыки, чтобы оставаться впереди в постоянно меняющемся технологическом мире.',
};
